// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wb_a bhk_b","TwoDimsListFeature__item":"wb_b bhk_wb","TwoDimsListFeature__item__text":"wb_c bhk_vr"};